module.exports = __webpack_public_path__ + "static/media/image3.aeac8b13.jpg";